import { useEffect, useRef, useState } from "react";
import { FaRunning, FaStore, FaHandshake, FaHands, FaMap } from "react-icons/fa";
import mascot from "../assets/wml1.webp";
import map from "../assets/Map.webp";
import tote from "../assets/SOWS tote.webp";
import sweater from "../assets/SOWS Sweater.webp";
import shirt from "../assets/SOWshirt.webp";
import runPhoto from "../assets/run.webp";
import marquee1 from "../assets/veiled.webp";
import marquee2 from "../assets/marquee 2.webp";
import platinum1 from "../assets/icpc.webp";
import platinum2 from "../assets/platinum 2.webp";
import gold1 from "../assets/gold 1.webp";
import gold2 from "../assets/gold 2.webp";
import gold3 from "../assets/gold 3.webp";
import silver1 from "../assets/silver 1.webp";
import silver2 from "../assets/silver 2.webp";
import silver3 from "../assets/silver 3.webp";

export default function VideoPage() {
  const videoRef = useRef(null);
  const [hovered, setHovered] = useState(false);
  const [activeTab, setActiveTab] = useState("runners");
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const [videoFailed, setVideoFailed] = useState(false);

  const rewards = [
    { price: "$15", label: "Tote", image: tote, link: "https://checkout.square.site/merchant/T78BP8HEH1HW7/checkout/J5I7SCPCPBNW4FVZ7RDWAHTT" },
    { price: "$25", label: "Shirt", image: shirt, link: "https://checkout.square.site/merchant/T78BP8HEH1HW7/checkout/EBQJFSRHY3GISC4NE7AIUSPZ" },
    { price: "$35", label: "Sweater", image: sweater, link: "https://checkout.square.site/merchant/T78BP8HEH1HW7/checkout/VPKH47HRIO3PZ4NPB2B7NSSB" },
  ];

  const [merchIndex, setMerchIndex] = useState(0);

  // Each logo carries its own aspect ratio (width / height of the trimmed artwork) so a
  // square logo (like ICPC) and a wide horizontal logo (like Brothers Produce) can be sized
  // to the same visual "area" within a tier instead of just the same height — that's what
  // was making the square ones look small next to the wide ones.
  const sponsorTiers = [
    {
      // PLATINUM — biggest tier; the 2 logos sit close together, centered, instead of
      // spread across the full row width
      area: { desktop: 64000, mobile: 12500 },
      maxWidth: { desktop: 400, mobile: 175 },
      maxHeight: { desktop: 300, mobile: 130 },
      justify: "center",
      gap: { desktop: "126px", mobile: "14px" },
      logos: [
        { src: platinum1, aspect: 0.89 }, // ICPC (near-square)
        { src: platinum2, aspect: 2.02 }, // Brothers Produce (wide)
      ],
    },
    {
      // GOLD — noticeably smaller than platinum
      area: { desktop: 28000, mobile: 5400 },
      maxWidth: { desktop: 330, mobile: 145 },
      maxHeight: { desktop: 170, mobile: 85 },
      logos: [
        { src: gold1, aspect: 3.38 }, // Cultura Athletic (very wide)
        { src: gold2, aspect: 0.99 }, // ISCU (square)
        { src: gold3, aspect: 2.38 }, // Excellent Printing & Signs (wide)
      ],
    },
    {
      // SILVER — about half the size of gold now (was too close to gold before)
      area: { desktop: 6500, mobile: 1250 },
      maxWidth: { desktop: 140, mobile: 60 },
      maxHeight: { desktop: 100, mobile: 42 },
      logos: [
        { src: silver1, aspect: 1.23 }, // Move with Meha
        { src: silver2, aspect: 2.05 }, // Islamic Relief USA
        { src: silver3, aspect: 1.02 }, // Maqlouba House
      ],
    },
  ];

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      setMerchIndex((currentIndex) => (currentIndex + 1) % rewards.length);
    }, 4000);
    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    document.body.classList.add("transparent-nav");
    return () => document.body.classList.remove("transparent-nav");
  }, []);

  const handleMouseEnter = () => {
    setHovered(true);
    if (videoRef.current) videoRef.current.pause();
  };

  const logoGlow = "drop-shadow(0 0 10px rgba(255,255,255,0.6)) drop-shadow(0 0 24px rgba(255,255,255,0.3))";

  const handleMouseLeave = () => {
    setHovered(false);
    if (videoRef.current) videoRef.current.play();
  };

  const sectionStyle = {
    background: "#f6f0dc",
    borderRadius: "24px",
    padding: isMobile ? "24px 20px" : "40px 50px",
    marginBottom: "24px",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    textAlign: "center"
  };

  const headingStyle = {
    color: "#e57386",
    fontSize: isMobile ? "22px" : "28px",
    fontWeight: "bold",
    marginBottom: "16px",
    marginTop: 0
  };

  const linkBtnStyle = {
    display: "inline-block",
    background: "#e57386",
    color: "black",
    padding: "14px 32px",
    borderRadius: "40px",
    textDecoration: "none",
    fontWeight: "bold",
    fontSize: "17px",
    marginTop: "12px",
    marginRight: "12px"
  };

  const sponsorCardStyle = {
    background: "#e57386",
    borderRadius: "24px",
    padding: isMobile ? "24px 20px" : "36px 50px",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    textAlign: "center"
  };

  const tabs = [
    { id: "runners", label: "Runners", icon: <FaRunning /> },
    { id: "vendors", label: "Vendors", icon: <FaStore /> },
    { id: "sponsors", label: "Sponsors", icon: <FaHandshake /> },
    { id: "volunteers", label: "Volunteers", icon: <FaHands /> },
  ];

  const SponsorCard = () => (
    <div style={sponsorCardStyle}>
      <h2 style={{ ...headingStyle, color: "black" }}>Our Sponsors</h2>
      <div style={{ display: "flex", flexDirection: "column", gap: isMobile ? "24px" : "36px", width: "100%" }}>
        {sponsorTiers.map((tier, i) => {
          const area = isMobile ? tier.area.mobile : tier.area.desktop;
          const maxW = isMobile ? tier.maxWidth.mobile : tier.maxWidth.desktop;
          const maxH = isMobile ? tier.maxHeight.mobile : tier.maxHeight.desktop;
          const justify = tier.justify || "space-evenly";
          const gap = tier.gap ? (isMobile ? tier.gap.mobile : tier.gap.desktop) : undefined;
          // Rows that are centered with a fixed gap (platinum) size cells to their content;
          // rows that spread evenly across the full width (gold/silver) let cells grow to fill it.
          const cellFlex = justify === "center" ? "0 0 auto" : "1 1 0";

          return (
            <div
              key={i}
              style={{
                display: "flex", justifyContent: justify, alignItems: "flex-end",
                width: "100%", height: maxH, gap
              }}
            >
              {tier.logos.map((logo, j) => {
                // Solve for a box with the target area that matches this logo's own aspect
                // ratio, so a square logo and a wide logo end up with equal visual weight
                // instead of just equal height.
                let w = Math.sqrt(area * logo.aspect);
                let h = Math.sqrt(area / logo.aspect);
                const scale = Math.min(1, maxW / w, maxH / h);
                w *= scale;
                h *= scale;

                return (
                  <div
                    key={j}
                    style={{
                      flex: cellFlex,
                      display: "flex", justifyContent: "center", alignItems: "flex-end",
                      height: maxH,
                      padding: cellFlex === "0 0 auto" ? 0 : (isMobile ? "0 8px" : "0 16px"),
                      boxSizing: "border-box"
                    }}
                  >
                    <img
                      src={logo.src}
                      alt="Sponsor"
                      style={{
                        width: w,
                        height: h,
                        objectFit: "contain",
                        filter: "drop-shadow(0 4px 10px rgba(0,0,0,0.2))"
                      }}
                    />
                  </div>
                );
              })}
            </div>
          );
        })}
      </div>
    </div>
  );

  return (
    <div>
      {/* VIDEO BANNER */}
      <div
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
        style={{
          position: "relative", width: "100vw", height: "100vh",
          overflow: "hidden", marginTop: "-80px",
          marginLeft: "calc(-50vw + 50%)"
        }}
      >
        {videoFailed ? (
          <img
            src={runPhoto}
            alt="Watermelon Run"
            style={{
              position: "absolute", top: "50%", left: "50%",
              transform: "translate(-50%, -50%)", minWidth: "100%",
              minHeight: "100%", objectFit: "cover", zIndex: 0
            }}
          />
        ) : (
          <video
            ref={videoRef}
            autoPlay
            loop
            muted
            playsInline
            onError={() => setVideoFailed(true)}
            style={{
              position: "absolute", top: "50%", left: "50%",
              transform: "translate(-50%, -50%)", minWidth: "100%",
              minHeight: "100%", objectFit: "cover", zIndex: 0
            }}
          >
            <source src="/myvideo.mp4" type="video/mp4" />
          </video>
        )}

        <div style={{
          position: "absolute", inset: 0,
          backgroundColor: hovered ? "rgba(0,0,0,0.75)" : "rgba(0,0,0,0.55)",
          transition: "background-color 0.4s ease", zIndex: 1
        }} />
        <div style={{
          position: "absolute", top: 0, left: 0, right: 0, height: "150px",
          background: "linear-gradient(to bottom, #2d3d12 0%, transparent 100%)", zIndex: 2
        }} />
        <div style={{
          position: "absolute", bottom: 0, left: 0, right: 0, height: "400px",
          background: "linear-gradient(to top, #2d3d12 0%, transparent 100%)", zIndex: 2
        }} />

        <div style={{
          position: "relative", zIndex: 3, display: "flex", flexDirection: "column",
          alignItems: "center", justifyContent: "center", height: "100%",
          textAlign: "center", padding: "0 20px", paddingTop: "80px"
        }}>
          <h1 style={{
            fontSize: "clamp(36px, 8vw, 130px)", fontWeight: "bold", marginBottom: "10px",
            color: "#e57386", textShadow: "0 0 30px rgba(0,0,0,1), 0 0 60px rgba(0,0,0,1)",
            WebkitTextStroke: "1px rgba(0,0,0,0.3)"
          }}>
            THE WATERMELON RUN
          </h1>
          <p style={{
            fontSize: "clamp(18px, 3vw, 48px)", fontWeight: "bold", marginBottom: "30px",
            color: "#e57386", textShadow: "0 0 20px rgba(0,0,0,1), 0 0 40px rgba(0,0,0,1)"
          }}>
            SEPTEMBER 26th, 2026
          </p>
          <div style={{
            display: "flex", gap: "20px", justifyContent: "center",
            alignItems: "center", flexWrap: "wrap", marginTop: "10px"
          }}>
            <a href="https://runsignup.com/Race/NJ/Paterson/TheWatermelonRun" style={linkBtnStyle}>Register Now</a>
            <a href="https://leonardeducation.org/the-seeds-of-a-watermelon-scholarship-fund/" style={{ ...linkBtnStyle }}>
              Donate
            </a>
          </div>
        </div>

   
      </div>

      {/* PAGE CONTENT */}
      <div style={{ backgroundColor: "#2d3d12", padding: "0 0 80px" }}>
        {/* MARQUEE SPONSOR LOGOS - sits over the green ombre fade at the bottom of the banner */}
        <div style={{
          position: "absolute", bottom: isMobile ? "16px" : "30px", left: 0, right: 0,
          zIndex: 3, display: "flex", justifyContent: "center", alignItems: "center",
          gap: isMobile ? "28px" : "64px", flexWrap: "wrap", padding: "0 20px"
        }}>
          <img src={marquee1} alt="Marquee Sponsor" style={{ height: isMobile ? "70px" : "170px", objectFit: "contain", filter: logoGlow }} />
          <img src={marquee2} alt="Marquee Sponsor" style={{ height: isMobile ? "70px" : "170px", objectFit: "contain", filter: logoGlow }} />
        </div>

        {/* TABS */}
        <div style={{
          display: "grid",
          gridTemplateColumns: "repeat(4, 1fr)",
          width: isMobile ? "95%" : "85%",
          margin: "0 auto",
          gap: isMobile ? "8px" : "16px",
          padding: isMobile ? "50px 0 30px" : "60px 0 16px"
        }}>
          {tabs.map(tab => (
            <div
              key={tab.id}
              onClick={() => setActiveTab(tab.id)}
              style={{ position: "relative", marginTop: "40px", cursor: "pointer" }}
            >
              {/* ICON */}
              <div style={{
                position: "absolute", top: "-30px", left: "50%",
                transform: "translateX(-50%)",
                width: isMobile ? "48px" : "72px",
                height: isMobile ? "48px" : "72px",
                borderRadius: "50%",
                background: activeTab === tab.id ? "#e57386" : "#f6f0dc",
                display: "flex", alignItems: "center", justifyContent: "center",
                fontSize: isMobile ? "18px" : "28px",
                color: activeTab === tab.id ? "white" : "#3d4f0c",
                border: "4px solid #2d3d12",
                boxShadow: activeTab === tab.id ? "0 6px 20px rgba(229,115,134,0.5)" : "none",
                transition: "all 0.2s", zIndex: 2
              }}>
                {tab.icon}
              </div>

              {/* CARD */}
              <div style={{
                background: activeTab === tab.id ? "#e57386" : "#f6f0dc",
                borderRadius: "16px",
                padding: isMobile ? "36px 6px 12px" : "50px 20px 24px",
                textAlign: "center", fontWeight: "bold",
                fontSize: isMobile ? "12px" : "20px",
                color: activeTab === tab.id ? "white" : "#3d4f0c",
                opacity: activeTab === tab.id ? 1 : 0.75,
                boxShadow: activeTab === tab.id ? "0 8px 24px rgba(229,115,134,0.4)" : "none",
                transform: activeTab === tab.id ? "translateY(-4px)" : "none",
                transition: "all 0.2s"
              }}>
                {tab.label}
              </div>
            </div>
          ))}
        </div>

        {/* TAB CONTENT */}
        <div style={{ width: isMobile ? "95%" : "85%", margin: "0 auto" }}>

          {/* RUNNERS TAB */}
          {activeTab === "runners" && (
            <div>
              {isMobile ? (
                /* ✅ MOBILE - single column: registration, route, merch, sponsors */
                <div style={{ display: "flex", flexDirection: "column", gap: "20px" }}>

                  {/* REGISTRATION */}
                  <div style={sectionStyle}>
                    <h2 style={headingStyle}>Registration</h2>
                    <p style={{ fontSize: "16px", lineHeight: "1.8" }}>
                      Sign up to participate in the Watermelon Run 2026! All ages and skill levels welcome.
                    </p>
                    <a href="https://runsignup.com/Race/NJ/Paterson/TheWatermelonRun" style={linkBtnStyle}>Register Here</a>
                  </div>

                  {/* RUN ROUTE */}
                  <div style={sectionStyle}>
                    <h2 style={headingStyle}><FaMap /> Run Route</h2>
                    <p style={{ fontSize: "16px", lineHeight: "1.8", marginBottom: "16px" }}>
                      Our 5K route takes you through the heart of Paterson, NJ!
                    </p>
                     <div style={{ position: "relative", width: "100%", aspectRatio: "1013 / 576", borderRadius: "20px", overflow: "hidden" }}>
                      <img src={map} alt="Run Route Map" style={{ width: "100%", height: "100%", objectFit: "cover" }} />
                      <img
                        src={mascot} alt="mascot"
                        style={{
                          position: "absolute", width: "50px", height: "50px",
                          objectFit: "contain", animation: "runRoute 12s linear infinite",
                          filter: "drop-shadow(2px 4px 6px rgba(0,0,0,0.4))"
                        }}
                      />
                    </div>
                    <div style={{
                      marginTop: "16px", background: "#e57386", borderRadius: "16px",
                      padding: "16px 20px", display: "flex", alignItems: "center",
                      gap: "12px", width: "100%", justifyContent: "center", boxSizing: "border-box"
                    }}>
                      <span style={{ fontWeight: "900", fontSize: "20px", color: "black" }}>🛒 Parking —</span>
                      <p style={{ margin: 0, fontWeight: "900", fontSize: "16px", color: "black" }}>Corrado's Grocery</p>
                    </div>
                  </div>

                  {/* MERCH */}
                  <div style={sectionStyle}>
                    <h2 style={headingStyle}>Buy Merch</h2>
                    <div style={{ width: "100%", height: "220px", display: "flex", alignItems: "center", justifyContent: "center" }}>
                      <img
                        src={rewards[merchIndex].image}
                        alt={rewards[merchIndex].label}
                        style={{ width: "100%", height: "100%", objectFit: "contain", borderRadius: "16px" }}
                      />
                    </div>
                    <a href={rewards[merchIndex].link} target="_blank" rel="noopener noreferrer"
                      style={{ ...linkBtnStyle, width: "100%", textAlign: "center", boxSizing: "border-box", margin: "16px 0 0", marginRight: 0 }}>
                      Buy {rewards[merchIndex].label} — {rewards[merchIndex].price}
                    </a>
                    <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: "16px", marginTop: "16px" }}>
                      <button onClick={() => setMerchIndex((merchIndex - 1 + rewards.length) % rewards.length)}
                        style={{ width: "36px", height: "36px", borderRadius: "50%", border: "none", background: "#e57386", color: "white", fontSize: "20px", cursor: "pointer" }}>←</button>
                      {rewards.map((_, index) => (
                        <div key={index} onClick={() => setMerchIndex(index)} style={{
                          width: index === merchIndex ? "12px" : "8px", height: index === merchIndex ? "12px" : "8px",
                          borderRadius: "50%", background: index === merchIndex ? "#e57386" : "#d0d0d0", cursor: "pointer"
                        }} />
                      ))}
                      <button onClick={() => setMerchIndex((merchIndex + 1) % rewards.length)}
                        style={{ width: "36px", height: "36px", borderRadius: "50%", border: "none", background: "#e57386", color: "white", fontSize: "20px", cursor: "pointer" }}>→</button>
                    </div>
                  </div>

                  {/* SPONSORS */}
                  <SponsorCard />

                </div>
              ) : (
                /* ✅ DESKTOP - original 2 column layout + full-width sponsor card at bottom */
                <div>
                  <div style={{ display: "grid", gridTemplateColumns: "1fr 2fr", gap: "24px", marginBottom: "24px" }}>

                    {/* LEFT COLUMN */}
                    <div style={{ display: "flex", flexDirection: "column", gap: "24px" }}>
                      <div style={sectionStyle}>
                        <h2 style={headingStyle}>Registration</h2>
                        <p style={{ fontSize: "17px", lineHeight: "1.8" }}>Sign up to participate in the Watermelon Run 2026! All ages and skill levels welcome.</p>
                        <a href="https://runsignup.com/Race/NJ/Paterson/TheWatermelonRun" style={linkBtnStyle}>Register Here</a>
                      </div>

                      <div style={sectionStyle}>
                        <h2 style={headingStyle}>Buy Merch</h2>
                        <div style={{ position: "relative", width: "100%", display: "flex", flexDirection: "column", alignItems: "center" }}>
                          <div style={{ width: "100%", height: "260px", display: "flex", alignItems: "center", justifyContent: "center", overflow: "hidden" }}>
                            <img src={rewards[merchIndex].image} alt={rewards[merchIndex].label}
                              style={{ width: "100%", height: "100%", objectFit: "contain", borderRadius: "16px" }} />
                          </div>
                          <a href={rewards[merchIndex].link} target="_blank" rel="noopener noreferrer"
                            style={{ ...linkBtnStyle, width: "100%", textAlign: "center", boxSizing: "border-box", margin: "16px 0 0" }}>
                            Buy {rewards[merchIndex].label} — {rewards[merchIndex].price}
                          </a>
                          <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: "20px", marginTop: "20px" }}>
                            <button onClick={() => setMerchIndex((merchIndex - 1 + rewards.length) % rewards.length)}
                              style={{ width: "42px", height: "42px", borderRadius: "50%", border: "none", background: "#e57386", color: "white", fontSize: "24px", fontWeight: "900", cursor: "pointer" }}>←</button>
                            <div style={{ display: "flex", gap: "8px", alignItems: "center" }}>
                              {rewards.map((_, index) => (
                                <div key={index} onClick={() => setMerchIndex(index)} style={{
                                  width: index === merchIndex ? "12px" : "9px", height: index === merchIndex ? "12px" : "9px",
                                  borderRadius: "50%", background: index === merchIndex ? "#e57386" : "#d0d0d0", cursor: "pointer", transition: "all 0.2s ease"
                                }} />
                              ))}
                            </div>
                            <button onClick={() => setMerchIndex((merchIndex + 1) % rewards.length)}
                              style={{ width: "42px", height: "42px", borderRadius: "50%", border: "none", background: "#e57386", color: "white", fontSize: "24px", fontWeight: "900", cursor: "pointer" }}>→</button>
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* RIGHT COLUMN - RUN ROUTE */}
                    <div style={sectionStyle}>
                      <h2 style={headingStyle}><FaMap /> Run Route</h2>
                      <p style={{ fontSize: "19px", lineHeight: "1.8", marginBottom: "24px" }}>Our 5K route takes you through the heart of Paterson, NJ!</p>
                      <div style={{ position: "relative", width: "100%", aspectRatio: "1013 / 576", borderRadius: "20px", overflow: "hidden" }}>
                        <img src={map} alt="Run Route Map" style={{ width: "100%", height: "100%", objectFit: "cover" }} />
                        <img src={mascot} alt="mascot"
                          style={{ position: "absolute", width: "80px", height: "80px", objectFit: "contain", animation: "runRoute 12s linear infinite", filter: "drop-shadow(2px 4px 6px rgba(0,0,0,0.4))" }} />
                      </div>
                      <div style={{
                        marginTop: "24px", background: "#e57386", borderRadius: "16px",
                        padding: "20px 30px", display: "flex", alignItems: "center",
                        gap: "16px", width: "100%", justifyContent: "center", boxSizing: "border-box"
                      }}>
                        <span style={{ fontWeight: "900", fontSize: "28px", color: "black" }}>Parking:</span>
                        <div style={{ textAlign: "left" }}>
                          <p style={{ margin: 0, fontWeight: "900", fontSize: "18px", color: "black" }}>Corrado's Grocery Parking</p>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* SPONSORS - full width at the bottom */}
                  <SponsorCard />
                </div>
              )}
            </div>
          )}

          {/* VENDORS TAB */}
          {activeTab === "vendors" && (
            <div>
              <div style={{ display: "grid", gridTemplateColumns: isMobile ? "1fr" : "1fr 1fr", gap: "24px" }}>
                <div style={sectionStyle}>
                  <h2 style={headingStyle}>Become a Vendor</h2>
                  <p style={{ fontSize: "17px", lineHeight: "1.8" }}>
                    Interested in setting up a table? Fill out the form below and we'll be in touch!
                  </p>
                  <a href="https://docs.google.com/forms/d/e/1FAIpQLSeEhm6kYpFnzfWJLmhBS5E3F2Jo6VXi8R0bqPWQzUKUgJ0j6Q/viewform" style={linkBtnStyle}>Vendor Application</a>
                </div>
                <div style={sectionStyle}>
                  <h2 style={headingStyle}>Where are the Vendors?</h2>
                  <p style={{ fontSize: "17px", lineHeight: "1.8" }}>
                    We'll have a variety of food and merchandise vendors at the event. A detailed map will be shared as we get closer to race day.
                  </p>
                </div>
              </div>
            </div>
          )}

          {/* SPONSORS TAB */}
          {activeTab === "sponsors" && (
            <div>
              <div style={sectionStyle}>
                <h2 style={headingStyle}>Become a Sponsor</h2>
                <p style={{ fontSize: "17px", lineHeight: "1.8", maxWidth: "700px" }}>
                  Sponsoring the Watermelon Run is a powerful way to show your commitment to education and community. All proceeds go directly to the SOWS Fund supporting Gazan students pursuing higher education. Click the link below to see more info about our different tiers!
                </p>
                <a href="https://docs.google.com/forms/d/e/1FAIpQLSfKxuGl0XJ6sIUsSUlw9zE6QfYqlq0pf6kWaaU2eowNnN1BGA/viewform" style={linkBtnStyle}>Sponsorship Form</a>
              </div>
            </div>
          )}

          {/* VOLUNTEERS TAB */}
          {activeTab === "volunteers" && (
            <div>
              <div style={sectionStyle}>
                <h2 style={headingStyle}>Volunteer with Us</h2>
                <p style={{ fontSize: "17px", lineHeight: "1.8", maxWidth: "700px" }}>
                  The Watermelon Run couldn't happen without our amazing volunteers! Whether you want to help at water stations, direct runners, or assist at the finish line — we'd love your help.
                </p>
                <a href="https://docs.google.com/forms/d/e/1FAIpQLScnvG2M4A6AEJE-ZDez51iWs2-JAQcnsrg42TnI-a0fxe-Kkg/viewform" style={linkBtnStyle}>Volunteer Form</a>
              </div>
            </div>
          )}

        </div>
      </div>
    </div>
  );
}